import tinycolor from 'tinycolor2';

function percentToInt(str) {
  // '20%' -> 20
  return parseInt(str.replace(/%/g, ''), 10);
}

function lighten(color, modifier) {
  return tinycolor(color).lighten(percentToInt(modifier)).toString();
}
function darken(color, modifier) {
  return tinycolor(color).darken(percentToInt(modifier)).toString();
}
function transparentize(color, modifier) {
  return tinycolor(color).setAlpha(modifier).toString();
}

export { darken, lighten, transparentize };
